// extracted by mini-css-extract-plugin
export default {"lineHight":"32","colorIndicator":"color-indicator_colorIndicator__2BjQP"};